import { useEffect, useState } from 'react';
import isCompositeImage from 'src/js/modules/common/helpers/is-composite-image';
import selectors from '../../../common/constants/selectors';

const useElementsToStick = ({ element, scrollPosition }) => {
  const [elementsToStick, setElementsToStick] = useState([]);

  useEffect(() => {
    function calculateElementsToStick() {
      const compositeGroup = element.closest(selectors.COMPOSITE_GROUP);
      const result = [
        {
          element: compositeGroup,
          elementBounds: compositeGroup.getBoundingClientRect(),
        },
      ];

      compositeGroup.querySelectorAll(selectors.COMPOSITE_ITEM).forEach((sibling) => {
        if (sibling !== element) {
          result.push({
            element: sibling,
            elementBounds: sibling.getBoundingClientRect(),
          });
        }
      });

      setElementsToStick(result);
    }

    const isCompositeItem = isCompositeImage(element);

    if (isCompositeItem) {
      calculateElementsToStick();
      window.addEventListener('resize', calculateElementsToStick, false);
    }

    return () => {
      if (isCompositeItem) {
        window.removeEventListener('resize', calculateElementsToStick, false);
      }
    };
  }, [element, scrollPosition]);

  return elementsToStick;
};

export default useElementsToStick;
